export const CUSTOM_CALCULATION_DATA_FIELD_KEY_PREFIX = 'custom_calculation__' as const;
export const CUSTOM_CALCULATION_DATA_FIELD_KEY_REGEX = new RegExp(
  String.raw`^${CUSTOM_CALCULATION_DATA_FIELD_KEY_PREFIX}\d+$`
);
